import {
  DictService,
  Dictionary,
  DictionaryEntry,
} from 'app/services/dict.service';
import { DictionariesEnum, LabelEnum } from 'app/shared/enums';
import { RequestParams } from 'app/services/api.service';
import { get, uniqBy } from 'lodash-es';

export const setHorsePowerDictionaryEntryValue = (item: DictionaryEntry) => {
  const { horsePower, powerKw } = item.carTypeDetails || {};

  return horsePower && powerKw ? `${horsePower} KM (${powerKw}kW)` : '';
};

export const parseCarVersionDictionary = (
  dictionary: Dictionary
): DictionaryEntry[] => {
  return dictionary.map((dictionaryEntry) => {
    const dictionaryEntryValue = dictionaryEntry.value as string;
    const [valueShort, ...subLabels] = dictionaryEntryValue.split(', ');

    return {
      ...dictionaryEntry,
      valueShort,
      subLabels,
    };
  });
};

export const parseProductionYearDictionary = (
  dictionary: Dictionary
): DictionaryEntry[] => {
  return dictionary.map((dictionaryEntry) => ({
    ...dictionaryEntry,
    key: parseInt(dictionaryEntry.key.toString()),
  }));
};

export const parseCarDoorsDictionary = (dictionary: Dictionary) => {
  return dictionary.map((dictionaryEntry) => ({
    ...dictionaryEntry,
    value: `${dictionaryEntry.value} ${LabelEnum.Doors}`,
  }));
};

export const setHorsePowerDictionary = (dictionary: Dictionary) => {
  const powerKwDictionaryKey = 'carTypeDetails.powerKw';

  const horsePowerOptions = uniqBy(dictionary, powerKwDictionaryKey).filter(
    (item) => item.key !== 'no_car_type'
  );

  const horsePowerDictionary = horsePowerOptions.map((item) => {
    const powerKw = get(item, powerKwDictionaryKey);

    return {
      key: powerKw,
      value: setHorsePowerDictionaryEntryValue(item),
    };
  });

  return horsePowerDictionary;
};

export const fetchDictionary = async (
  answersDictionaryKey: string,
  paramValues: RequestParams
) => {
  const { data: dictionary } = await DictService.getDictionary(
    answersDictionaryKey,
    paramValues
  );

  if (
    [
      DictionariesEnum.CarModelVersions,
      DictionariesEnum.InfoekspertModelVersions,
      DictionariesEnum.MotorcycleModelVersions,
    ].includes(answersDictionaryKey as DictionariesEnum)
  ) {
    return parseCarVersionDictionary(dictionary);
  }

  if (answersDictionaryKey === DictionariesEnum.CarDoors) {
    return parseCarDoorsDictionary(dictionary);
  }

  return dictionary;
};

export const removeHorsePowerValueFromVersionEt = (item: DictionaryEntry) =>
  item.value
    .split(',')
    .filter((value) => !value.includes(' KM '))
    .join(',');

export const removeHorsePowerSublabelFromVersionEt = (item: DictionaryEntry) =>
  item.subLabels && item.subLabels.filter((item, index) => index > 0);
